import React from 'react'
import { Box } from "grommet"

export const List = props => <Box fill gap="none" pad="none" margin="none" tag="ul" {...props} />

export const ListItem = props => (
    <Box
        onClick={()=>{}}
        hoverIndicator={{ color: "light-2" }}
        tag="li"
        pad="xsmall"
        gap="xsmall"
        margin="none"
        // direction="row"
        justify="between"
        alignContent="start"
        {...props}
    />
)
